export const packIds = ['pack'] as const;
export const commonIds = [
	'area',
	'length',
	'volume',
	// other which means quantity
	'each',
	'bag',
	'roll',
	'sheet',
	'pail',

	// carters
	'bale',
	'bundle',
	'box',
	'coil',
	'jar',
	'meterCubed',
	'meter',
	'pair',
] as const;

export const ids = [...packIds, ...commonIds] as const;
